import { Link } from "react-router-dom";
import { CONTACT, NAV_LINKS } from "@/data/content";

export const Footer = () => (
  <footer className="border-t border-gold/15 bg-noir" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col gap-10 border-b border-gold/15 py-14 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <img src="/images/logo-duo.png" alt="Root2Shoot — Sustainable Café and Film & TV Catering" className="h-20 w-auto sm:h-24" />
          <p className="mt-6 font-display text-xl italic text-gold">Good food. Brighter futures.</p>
        </div>
        <p className="max-w-sm text-sm leading-relaxed text-sage">
          Sustainable café, open to the public — and sustainable film &amp; TV catering, delivered
          hot to set. Good food, grown from community, served with soul.
        </p>
      </div>

      <div className="grid gap-12 py-14 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <p className="label-mono mb-6">Explore</p>
          <ul className="space-y-3">
            {NAV_LINKS.map((link) => (
              <li key={link.to}>
                <Link to={link.to} data-testid={`footer-${link.testid}`} className="text-sm text-sage transition-colors hover:text-gold">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="label-mono mb-6">Talk to Us</p>
          <ul className="space-y-4 text-sm">
            <li>
              <span className="block font-mono text-[10px] uppercase tracking-[0.25em] text-sage/60">Email</span>
              <a href={`mailto:${CONTACT.email}`} className="mt-1 block text-gold underline-offset-4 transition-colors hover:text-gold-light hover:underline" data-testid="footer-email">
                {CONTACT.email}
              </a>
            </li>
            <li>
              <span className="block font-mono text-[10px] uppercase tracking-[0.25em] text-sage/60">Phone</span>
              <a href={CONTACT.phoneHref} className="mt-1 block text-cream transition-colors hover:text-gold" data-testid="footer-phone">
                {CONTACT.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="text-sage underline-offset-4 transition-colors hover:text-gold hover:underline" data-testid="footer-whatsapp">
                Also on WhatsApp
              </a>
            </li>
          </ul>
        </div>
        <div>
          <p className="label-mono mb-6">Visit the Café</p>
          <address className="text-sm not-italic leading-relaxed text-sage">
            {CONTACT.addressLines[0]}<br />
            {CONTACT.addressLines[1]}<br />
            {CONTACT.postcode}
          </address>
          <p className="mt-4 text-sm leading-relaxed text-sage">
            {CONTACT.hoursWeekday}<br />
            {CONTACT.hoursWeekend}
          </p>
        </div>
        <div>
          <p className="label-mono mb-6">Production Catering</p>
          <p className="text-sm leading-relaxed text-sage">
            Feeding crews on location, in studio and on set. Tell us about your production.
          </p>
          <Link to="/catering#enquiry" className="btn-ghost mt-6 !px-5 !py-2.5" data-testid="footer-cta-enquire">
            Start an Enquiry
          </Link>
        </div>
      </div>

      <div className="border-t border-gold/15 py-7 text-center">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold/70">
          Good Food&nbsp;&nbsp;|&nbsp;&nbsp;Lower Impact&nbsp;&nbsp;|&nbsp;&nbsp;Brighter Tomorrows
        </p>
        <p className="mt-3 text-xs text-sage/70">© {new Date().getFullYear()} Root2Shoot. Good food. Brighter futures.</p>
      </div>
    </div>
  </footer>
);
